/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-12 10:38:33
 * @LastEditors: K
 * @LastEditTime: 2022-09-23 09:36:27
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootThunkApi } from '../../app/store'
import { api, sendAsync } from '../.././app/applicationSlice'
import {
  ImportExcelParams,
  getpatientsExcelFn,
  getpatientsDiagnosisExcelFn,
  getchargeExcelFn,
  getDentistHousekeeperExcelFn,
  getHerbsExcelFn,
  YunDiDrugImportExcel,
  YunDiTreatmentImportExcel,
  YunDiInventoryImportExcel,
  YunDiMaterialImportExcel,
  tenantDataInit, tenantDataSendSms, goTenantDataInitDo,
} from '../../services/purchaseModal'
import * as ST from "../../services/tenant";
import {tenantDataInitParams} from "../../services/tenant";
// 患者导入 excel
export const getpatientsExcel = createAsyncThunk<
  void,
  ImportExcelParams,
  RootThunkApi
>('/commodity/getpatientsExcel', async (body, api) => {
  return sendAsync(getpatientsExcelFn(body), api)
})

// 患者诊断信息导入 excel
export const getpatientsDiagnosisExcel = createAsyncThunk<
  void,
  ImportExcelParams,
  RootThunkApi
>('/commodity/getpatientsDiagnosisExcel', async (body, api) => {
  return sendAsync(getpatientsDiagnosisExcelFn(body), api)
})

// 收费导入 excel
export const getchargeExcel = createAsyncThunk<
  void,
  ImportExcelParams,
  RootThunkApi
>('/commodity/getchargeExcel', async (body, api) => {
  return sendAsync(getchargeExcelFn(body), api)
})

// 牙医管家诊断模板导入 excel
export const getDentistHousekeeperExcel = createAsyncThunk<
  void,
  ImportExcelParams,
  RootThunkApi
>('/commodity/getDentistHousekeeperExcel', async (body, api) => {
  return sendAsync(getDentistHousekeeperExcelFn(body), api)
})
// 代煎饮片厂-商品目录 or 代煎机构-商品目录导出  excel
export const getHerbsExcel = createAsyncThunk<
  void,
  ImportExcelParams,
  RootThunkApi
>('/commodity/getHerbsExcel', async (body, api) => {
  return sendAsync(getHerbsExcelFn(body), api)
})

export const YunDiDrugImportExcelAsync = createAsyncThunk<
  void,
  ST.ImportExcelParams,
  RootThunkApi
>('/commodity/YunDiDrugImportExcelAsync', async (body, api) => {
  return sendAsync(YunDiDrugImportExcel(body), api)
})

export const YunDiTreatmentImportExcelAsync = createAsyncThunk<
  void,
  ST.ImportExcelParams,
  RootThunkApi
>('/commodity/YunDiTreatmentImportExcelAsync', async (body, api) => {
  return sendAsync(YunDiTreatmentImportExcel(body), api)
})


export const YunDiInventoryImportExcelAsync = createAsyncThunk<
  void,
  ST.ImportExcelParams,
  RootThunkApi
>('/commodity/YunDiInventoryImportExcelAsync', async (body, api) => {
  return sendAsync(YunDiInventoryImportExcel(body), api)
})


export const YunDiMaterialImportExcelAsync = createAsyncThunk<
  void,
  ST.ImportExcelParams,
  RootThunkApi
>('/commodity/YunDiMaterialImportExcelAsync', async (body, api) => {
  return sendAsync(YunDiMaterialImportExcel(body), api)
})
export const tenantDataInitAsync = createAsyncThunk<
  void,
  ST.tenantDataInitParams,
  RootThunkApi
  >('/commodity/tenantDataInitAsync', async (body, api) => {
  return sendAsync(tenantDataInit(body), api)
})
export const tenantDataSendSmsAsync = createAsyncThunk<
  void,
  ST.tenantDataInitParams,
  RootThunkApi
  >('/commodity/tenantDataSendSmsAsync', async (body, api) => {
  return sendAsync(tenantDataSendSms(body), api)
})
export const goTenantDataInitDoAsync = createAsyncThunk<
  void,
  ST.tenantDataInitParams,
  RootThunkApi
  >('/commodity/goTenantDataInitDoAsync', async (body, api) => {
  return sendAsync(goTenantDataInitDo(body), api)
})